export const navbar = {
  Search: 'Search',
  SearchPlaceholder: 'What do you want to play?',
  Home: 'Home',
  'Your Library': 'Your Library',
  'Collapse your library': 'Collapse your library',
  'Expand your library': 'Expand your library',
  Language: 'Language',
  'Contact me': 'Contact me',
  'Choose a language': 'Choose a language',
};
